import type { AuthorProfile } from 'bundles/discussions/lib/types';
import { CourseRole } from 'bundles/discussions/lib/types';

export function isString(input: unknown): input is string {
  return typeof input === 'string';
}

export function isAnswerId(id: unknown): boolean {
  if (typeof id === 'string') {
    return /^\w+-\w+-\w+$/.test(id);
  }
  return false;
}

export function isContributorProfile(profile: unknown): profile is AuthorProfile {
  if (profile && typeof profile === 'object') {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (typeof profile.userId === 'number') {
      return true;
    }
  }
  return false;
}

export function isCourseRole(role: unknown): role is CourseRole {
  if (typeof role === 'string') {
    if (role in CourseRole) {
      return true;
    }
  }
  return false;
}
